import React from "react";
import { Sidebar } from 'flowbite-react';
import { FaFacebookSquare, FaGithubSquare, FaLinkedin } from 'react-icons/fa';
import '../css/sidebar.css';


function SideBar() {
    return (
    <Sidebar className="socialSidebar">
        <Sidebar.Items>
          <Sidebar.ItemGroup className="itemsSidebar">
            <Sidebar.Item href="https://www.facebook.com/miguel.castrillon128" target="_blank" icon={ FaFacebookSquare } className="facebook"></Sidebar.Item>
            <Sidebar.Item href="https://github.com/MiguelCastrillon" target="_blank" icon={ FaGithubSquare } className="github" ></Sidebar.Item>
            <Sidebar.Item href="https://www.linkedin.com/in/miguel-angel-castrillon-balvin-947228263" target="_blank" icon={ FaLinkedin} className="linkedin" ></Sidebar.Item>
          </Sidebar.ItemGroup>
        </Sidebar.Items>
    </Sidebar>
    );
}

export default SideBar;